import { useContext } from 'react';
import {
  AddressDispatchContext,
  HouseStateContext,
  StreetStateContext,
} from '../model/provider';

export const useStreetState = () => useContext(StreetStateContext);
export const useHouseState = () => useContext(HouseStateContext);
export const useAddressDispatch = () => useContext(AddressDispatchContext);
